var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14PoweredUsbHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M779.653 538.435H806.264V540.593C806.264 541.698 805.368 542.593 804.264 542.593H781.653C780.548 542.593 779.653 541.698 779.653 540.593V538.435Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1989_6519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M812.806 537.657C812.966 537.665 813.09 537.801 813.083 537.962C813.062 538.393 812.849 538.774 812.516 539.101C812.185 539.426 811.723 540.545 811.165 540.8C810.048 541.311 808.484 541.724 806.639 542.048C802.943 542.697 798.046 543.004 793.149 543C788.252 542.996 783.339 542.681 779.61 542.082C777.748 541.784 776.167 541.412 775.028 540.966C774.459 540.744 773.985 539.665 773.64 539.39C773.296 539.115 773.049 538.787 773.002 538.398C772.983 538.239 773.097 538.094 773.256 538.075C773.416 538.055 773.561 538.169 773.58 538.329C773.601 538.504 773.72 538.709 774.003 538.935C774.284 539.159 774.698 539.38 775.24 539.592C776.322 540.016 777.856 540.38 779.703 540.676C783.391 541.268 788.272 541.582 793.15 541.586C798.028 541.59 802.889 541.284 806.538 540.643C808.366 540.322 809.872 539.92 810.923 539.439C811.448 539.199 811.844 538.946 812.108 538.686C812.37 538.428 812.49 538.178 812.501 537.934C812.509 537.774 812.645 537.649 812.806 537.657Z",
    fill: "#D14FFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M773.102 523.811C773.295 527.286 812.717 526.852 812.886 523.811V536.117C812.886 538.708 810.898 540.874 808.314 541.064C797.008 541.898 789.165 541.9 777.678 541.061C775.091 540.872 773.102 538.706 773.102 536.112V523.811Z",
    fill: "#282524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M776.192 513.892L773.29 522.563C772.841 523.978 773.096 525.566 774.928 526.072C782.903 528.275 804.15 528.026 811.102 526.001C812.345 525.639 813.152 524.222 812.791 522.979L809.776 513.99C809.26 512.214 807.632 510.992 805.783 510.992H780.155C778.343 510.992 776.74 512.165 776.192 513.892Z",
    fill: "url(#paint0_linear_1989_6519)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M812.806 523.52C812.966 523.527 813.09 523.664 813.083 523.824C813.062 524.256 812.849 524.636 812.516 524.964C812.185 525.289 811.723 525.576 811.165 525.832C810.048 526.343 808.484 526.755 806.639 527.079C802.943 527.729 798.046 528.035 793.149 528.031C788.252 528.027 783.339 527.712 779.61 527.114C777.748 526.815 776.167 526.443 775.028 525.997C774.459 525.775 773.985 525.528 773.64 525.252C773.296 524.978 773.049 524.65 773.002 524.261C772.983 524.102 773.097 523.957 773.256 523.937C773.416 523.918 773.561 524.032 773.58 524.192C773.601 524.367 773.72 524.571 774.003 524.797C774.284 525.022 774.698 525.243 775.24 525.455C776.322 525.879 777.856 526.242 779.703 526.539C783.391 527.131 788.272 527.445 793.15 527.449C798.028 527.453 802.889 527.147 806.538 526.506C808.366 526.185 809.872 525.783 810.923 525.302C811.448 525.062 811.844 524.809 812.108 524.549C812.37 524.291 812.49 524.041 812.501 523.797C812.509 523.636 812.645 523.512 812.806 523.52Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M779.735 524.642C779.735 524.527 779.829 524.434 779.943 524.434H782.022C782.137 524.434 782.23 524.527 782.23 524.642C782.23 524.757 782.137 524.85 782.022 524.85H779.943C779.829 524.85 779.735 524.757 779.735 524.642Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.557 524.642C785.557 524.527 785.65 524.434 785.765 524.434H787.844C787.958 524.434 788.052 524.527 788.052 524.642C788.052 524.757 787.958 524.85 787.844 524.85H785.765C785.65 524.85 785.557 524.757 785.557 524.642Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791.378 524.642C791.378 524.527 791.471 524.434 791.586 524.434H793.665C793.78 524.434 793.873 524.527 793.873 524.642C793.873 524.757 793.78 524.85 793.665 524.85H791.586C791.471 524.85 791.378 524.757 791.378 524.642Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M797.199 524.642C797.199 524.527 797.292 524.434 797.407 524.434H799.486C799.601 524.434 799.694 524.527 799.694 524.642C799.694 524.757 799.601 524.85 799.486 524.85H797.407C797.292 524.85 797.199 524.757 797.199 524.642Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M803.02 524.642C803.02 524.527 803.114 524.434 803.228 524.434H805.307C805.422 524.434 805.515 524.527 805.515 524.642C805.515 524.757 805.422 524.85 805.307 524.85H803.228C803.114 524.85 803.02 524.757 803.02 524.642Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1989_6519",
    x: 771,
    y: 535.657,
    width: 44.083,
    height: 9.34277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1989_6519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_6519",
    x1: 792.988,
    y1: 510.992,
    x2: 792.988,
    y2: 527.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565251"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14PoweredUsbHub);
export default __webpack_public_path__ + "static/media/14PoweredUSBHub.2a164cae02f50610201d1ac34ff3604f.svg";
export { ForwardRef as ReactComponent };